var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronUpMedium = function SvgChevronUpMedium(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0A8447",
    d: "M21.207 16.692a1 1 0 0 1-1.414 0l-7.778-7.778-7.778 7.778a1 1 0 0 1-1.415-1.414l8.486-8.485a1 1 0 0 1 1.414 0l8.485 8.485a1 1 0 0 1 0 1.414"
  })));
};
export default SvgChevronUpMedium;